module.exports = __webpack_public_path__ + "static/klimova-e3bd4a09773edd7d53cea2a0d4bcac0b.jpg";